import React from 'react';
import { useTheme } from 'emotion-theming';

const Youtube = ({ color, ...props }) => {
    const theme = useTheme();
    const iconColor = color ? color : theme.colorMap.greyLightTwo;
    return (
        <svg
            aria-label="YouTube"
            width="20"
            height="20"
            viewBox="0 0 16 11"
            {...props}
        >
            <g>
                <path
                    fill={iconColor}
                    d="M12 5.502a.521.521 0 0 0-.281-.491l-4.8-2.915a.58.58 0 0 0-.61-.018.54.54 0 0 0-.309.51v5.83c0 .23.103.4.31.51.1.048.196.072.29.072.125 0 .231-.03.319-.091l4.8-2.915A.521.521 0 0 0 12 5.502zm4-.002c0 .55-.003.98-.009 1.29-.006.308-.031.7-.076 1.172a9.168 9.168 0 0 1-.2 1.268c-.096.418-.301.77-.617 1.057a1.915 1.915 0 0 1-1.107.498C12.67 10.928 10.673 11 8 11c-2.673 0-4.67-.072-5.991-.215a1.936 1.936 0 0 1-1.112-.498 1.98 1.98 0 0 1-.62-1.057 10.265 10.265 0 0 1-.192-1.268C.04 7.49.015 7.098.009 6.79A71.28 71.28 0 0 1 0 5.5c0-.55.003-.98.009-1.29.006-.308.031-.7.076-1.172.044-.473.111-.895.2-1.268C.382 1.352.587 1 .903.713A1.915 1.915 0 0 1 2.009.215C3.33.072 5.327 0 8 0c2.673 0 4.67.072 5.991.215.423.046.793.212 1.112.498.318.287.525.64.62 1.057.084.373.148.795.192 1.268.045.473.07.864.076 1.173.006.31.009.739.009 1.289z"
                />
            </g>
        </svg>
    );
};
export default Youtube;
